import React, { useEffect, createElement } from 'react';
const TITLE = '70 let in še brca — DANI SITER | Vabilo na praznovanje';
const DESCRIPTION = 'Vabljeni na praznovanje 70. rojstnega dne Danija Siterja v nedeljo, 5. 7. 2026 — sv. maša ob 11.00 in piknik od 13.00 na Kobilah pri Leskovcu pri Krškem. Prosimo za potrditev udeležbe.';
const URL = 'https://www.magicpatterns.app/';
const IMAGE = 'https://cdn.magicpatterns.com/uploads/jLAW6i6fotXktQpsdmqdVe/image_(4).png';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}
/**
 * Lightweight, dependency-free SEO/meta manager.
 * Sets the document title, meta description, language, and social cards.
 */
export function Seo() {
  useEffect(() => {
    document.documentElement.lang = 'sl';
    document.title = TITLE;
    setMeta('name', 'description', DESCRIPTION);
    setMeta('name', 'keywords', 'Dani Siter, 70 let, rojstni dan, praznovanje, vabilo, Leskovec pri Krškem, piknik');
    setMeta('name', 'author', 'Družina Siter');
    setMeta('name', 'robots', 'index, follow');
    setMeta('name', 'theme-color', '#4A4B2F');
    // Open Graph
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:locale', 'sl_SI');
    setMeta('property', 'og:title', TITLE);
    setMeta('property', 'og:description', DESCRIPTION);
    setMeta('property', 'og:url', URL);
    setMeta('property', 'og:image', IMAGE);
    setMeta('property', 'og:site_name', 'DANI 70');
    // Twitter
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', TITLE);
    setMeta('name', 'twitter:description', DESCRIPTION);
    setMeta('name', 'twitter:image', IMAGE);
    setLink('canonical', URL);
    // Structured data (Event) for rich results
    const ldId = 'ld-json-event';
    let script = document.getElementById(ldId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = ldId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: '70 let in še brca — Dani Siter',
      startDate: '2026-07-05T11:00:00+02:00',
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      description: DESCRIPTION,
      location: {
        '@type': 'Place',
        name: 'Prostor za piknike na Kobilah',
        address: 'Kobile pri Leskovcu pri Krškem, Slovenija'
      },
      organizer: {
        '@type': 'Organization',
        name: 'Družina Siter'
      }
    });
  }, []);
  return null;
}